import "./BoxModule.css"
import Module from "../../Model/Module";
import Loc from "../../../Loc/Loc";

interface BoxModuleProps {
    box: Module;
    setPageOnClick: (page: string) => void;
}

export default function BoxModule (props : BoxModuleProps) {
    const displayNbrOfDocs: boolean = props.box.NbrOfDocs !== -1;
    return (
        <div className="BoxModule" style={{background: props.box.Background}}>
            <div className="BoxModule-nbrOfDocs">{displayNbrOfDocs && (props.box.isLoaded ? props.box.NbrOfDocs : Loc.trad().BoxModuleLoad)} {!displayNbrOfDocs && <br/>} {displayNbrOfDocs && (props.box.isLoaded && (props.box.NbrOfDocs > 1 ? Loc.trad().BoxModulePlural : Loc.trad().BoxModuleSingular))}</div>
            <div className="BoxModule-name">{props.box.Name}</div>
            <div className="BoxModule-desc">{props.box.Description}</div>
            <img className="BoxModule-logo" src={props.box.Logo} alt={Loc.trad().BoxModuleAlt}></img>
            <div className="BoxModule-url" onClick={() => props.setPageOnClick(props.box.Page)}>{props.box.Url}</div>
        </div>
    );
}